import { TOPIC_NAMES } from 'crm-message-bus/types/MessageTopics';
export const OPEN_ACTIVITY_TIMELINE_SIDEBAR_HANDLER = {
  topic: TOPIC_NAMES.OPEN_ACTIVITY_TIMELINE_SIDEBAR,
  type: 'MODAL',
  componentLoader: () => import('../wrappers/ActivityTimelineSidebarWrapper')
};